import {useLoadEntityWithAllParents} from '../../../containers/EntityPath'
import withHook from '../../../hocs/withHook'
import {useProjectOrBuildTypeNodeFromUrl, useQueryParams} from '../../../hooks/routes'
import {getFullPath} from '../../../selectors'
import {getProjectBuildTypeFilter} from '../../../types'
import {emptyArray} from '../../../utils/empty'

import BuildPath from './BuildPath'
import type {BuildPathOwnProps, StateProps} from './BuildPath.types'

import {useAppSelector} from 'src/hooks/react-redux'

export default withHook<StateProps, BuildPathOwnProps>(
  ({projectOrBuildTypeNode, leafBuildTypeId}) => {
    const filterFromUrl = useProjectOrBuildTypeNodeFromUrl()
    const {buildTypeId, projectId} = useQueryParams()
    useLoadEntityWithAllParents({buildTypeId: leafBuildTypeId})
    return {
      projectOrBuildTypeNode:
        projectOrBuildTypeNode ??
        filterFromUrl ??
        getProjectBuildTypeFilter({projectId, buildTypeId}),
      path: useAppSelector(state =>
        leafBuildTypeId != null
          ? getFullPath(state, {
              nodeType: 'bt',
              id: leafBuildTypeId,
            })
          : emptyArray,
      ),
    }
  },
)(BuildPath)
